/* ================================================================
   LIVEFASTCULTURE — GLOBAL ERROR HANDLER
   Loaded first, inline, in <head>, on every page (see the very top
   of layout/theme.liquid) — before theme.css/theme.js/lf-ecosystem.js
   or anything else, so it's already listening before any other
   script on the page has a chance to run.

   WHAT THIS DOES:
   Catches (1) uncaught JS errors and (2) unhandled promise rejections
   anywhere on the site, and logs them clearly to the browser console
   with real context (which file, which line, the actual error) —
   instead of an error happening somewhere on the page with no trace
   anyone could find later. This is a visibility net, not a repair
   tool: it can't undo a broken feature, it just makes sure a broken
   feature is easy to spot and diagnose (open the browser console —
   Cmd+Option+J on Mac Chrome, Ctrl+Shift+J on Windows Chrome — any
   real error shows up prefixed "[LIVEFASTCULTURE]").

   WHAT THIS DELIBERATELY DOES NOT DO:
   - Never shows anything to a visitor — no alert(), no on-page
     banner, no redirect. A visitor sees nothing different whether
     this fires or not.
   - Never blocks or swallows the browser's own error reporting —
     this listens alongside it, it doesn't replace it.
   - Never retries/reloads/auto-fixes anything on its own. Silent
     auto-recovery attempts are exactly how a small bug turns into a
     confusing one (e.g. a reload loop) — a human should decide what
     to do once an error is actually seen.

   This is the same "fail quiet, log it, keep the page usable" pattern
   already used feature-by-feature throughout this theme (the FM
   overrides loader, the home page background video, YouTube thumbnail
   onerror fallbacks, etc.) — this is just the one catch-all net
   underneath all of those, for anything that isn't already covered
   by one of those specific fallbacks.
================================================================ */
(function () {
  // Guard against double-init — same pattern every other inline
  // script in this theme already uses (see e.g. page.culturestudio.liquid's
  // __lfStudioPageBound), in case this ever gets included twice.
  if (window.__lfErrorHandlerInit) return;
  window.__lfErrorHandlerInit = true;

  var LABEL = '[LIVEFASTCULTURE]';

  function safeLog(kind, detail) {
    // console.error itself throwing is effectively impossible in any
    // real browser, but this whole file exists to handle "effectively
    // impossible" — wrapped for the same reason.
    try {
      console.error(LABEL + ' ' + kind, detail);
    } catch (e) { /* nothing further to do if console is unavailable */ }
  }

  window.addEventListener('error', function (event) {
    // Covers uncaught script errors (a real bug in a script) AND
    // resource-load failures (broken image/video/script src) — the
    // latter mostly already have their own onerror fallback elsewhere
    // (YouTube thumbnail fallback, home bg video's own error listener,
    // etc.), so this is just a backstop for anything that doesn't.
    safeLog('Uncaught error', {
      message: event.message,
      source:  event.filename,
      line:    event.lineno,
      col:     event.colno,
      stack:   event.error && event.error.stack
    });
  }, true); // capture phase — resource-load errors don't bubble

  window.addEventListener('unhandledrejection', function (event) {
    // Every fetch()/async call this theme makes already has its own
    // try/catch (FM playlist/mixes/overrides loaders, etc.), so this
    // only ever fires for a genuinely uncaught rejection — a real gap
    // worth knowing about, not routine noise.
    safeLog('Unhandled promise rejection', event.reason);
  });
})();
